module.exports = __webpack_public_path__ + "static/media/b1.143da863.jpg";